if (!customElements.get('featured-collection-section')) {
    // js/sections/FeaturedCollectionSection.js
    var import_flickity2 = __toESM(require_js());
    class FeaturedCollectionSection extends HTMLElement {
    constructor() {
        super();
        this.delegateElement = new main_default(this);
        this.options = JSON.parse(this.getAttribute("data-section-settings"));
        if (!this.options["stackable"]) {
        this.flickityInstance = new import_flickity2.default(this.querySelector(".product-list"), {
            watchCSS: true,
            pageDots: false,
            prevNextButtons: true,
            contain: true,
            resize: false,
            groupCells: true,
            cellAlign: "left",
            draggable: !window.matchMedia("(-moz-touch-enabled: 0), (hover: hover)").matches
        });
        let lastWidth = window.innerWidth;
        window.addEventListener("resize", () => {
            if (window.innerWidth !== lastWidth) {
            this.flickityInstance.resize();
            lastWidth = window.innerWidth;
            }
        });
        }
        this.productItemColorSwatch = new ProductItemColorSwatch(this);
        this._fixSafari();
        this._attachListeners();
    }
    onUnload() {
        if (!this.options["stackable"]) {
        this.flickityInstance.destroy();
        }
        window.removeEventListener("resize", this._fixSafariListener);
        this.delegateElement.off("change");
        this.productItemColorSwatch.destroy();
        if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        }
    }
    _attachListeners() {
        this._fixSafariListener = this._fixSafari.bind(this);
        window.addEventListener("resize", this._fixSafariListener);
        this.delegateElement.on("click", '[data-action="add-to-cart"]', this._addToCart.bind(this));
        this.delegateElement.on("click", '[data-secondary-action="open-quick-view"]', this._openQuickView.bind(this));
        if (window.ResizeObserver && this.flickityInstance) {
        this.resizeObserver = new ResizeObserver(() => {
            this.flickityInstance.resize();
        });
        this.querySelectorAll(".product-item").forEach((item) => {
            this.resizeObserver.observe(item);
        });
        }
    }
    /**
     * On Safari 11.1 and lower, the browser incorrectly calculate the height of flex and grid items due to a bug
     * on how padding percentage is calculated (that we use for allocating image space). This is solved in Safari 11.1 and higher.
     *
     * For those browsers, we fix that in JavaScript by setting the height directly for each aspect ratio image
     *
     * @private
     */
    _fixSafari() {
        const userAgent = window.navigator.userAgent.toLowerCase();
        if (userAgent.includes("safari") && (userAgent.includes("version/10.1") || userAgent.includes("version/10.3") || userAgent.includes("version/11.0"))) {
        const isPhone = Responsive.matchesBreakpoint("phone");
        this.querySelectorAll(".product-item__image-wrapper .aspect-ratio, .product-item__image-wrapper .placeholder-svg").forEach((image) => {
            if (isPhone) {
            image.parentNode.style.height = null;
            } else {
            image.parentNode.style.height = `${image.clientHeight}px`;
            }
        });
        }
    }
    _openQuickView(event2, target) {
        let productUrl = new URL(`${window.location.origin}${target.getAttribute("data-product-url")}`);
        if (Responsive.matchesBreakpoint("phone") || Responsive.matchesBreakpoint("tablet")) {
        window.location.href = productUrl.href;
        return false;
        }
        let modal = document.getElementById(target.getAttribute("aria-controls"));
        modal.classList.add("is-loading");
        productUrl.searchParams.set("view", "quick-view");
        fetch(productUrl.href, {
        credentials: "same-origin",
        method: "GET"
        }).then((response) => {
        response.text().then((content) => {
            modal.querySelector(".modal__inner").innerHTML = content;
            modal.classList.remove("is-loading");
            let modalProductSection = new ProductSection(modal.querySelector('[data-section-type="product"]'));
            let doCleanUp = () => {
            modalProductSection.onUnload();
            modal.removeEventListener("modal:closed", doCleanUp);
            };
            modal.addEventListener("modal:closed", doCleanUp);
        });
        });
    }
    /**
     * ---------------------------------------------------------------------------------------------------
     * INTERNAL CODE THAT HANDLE PRODUCT ADD TO CART
     * ---------------------------------------------------------------------------------------------------
     */
    _addToCart(event2, target) {
        if (window.theme.cartType === "page") {
        return;
        }
        event2.preventDefault();
        event2.stopPropagation();
        target.setAttribute("disabled", "disabled");
        document.dispatchEvent(new CustomEvent("theme:loading:start"));
        const formElement = target.closest('form[action*="/cart/add"]');
        fetch(`${window.routes.cartAddUrl}.js`, {
        body: JSON.stringify(Form.serialize(formElement)),
        credentials: "same-origin",
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest"
            // This is needed as currently there is a bug in Shopify that assumes this header
        }
        }).then((response) => {
        target.removeAttribute("disabled");
        if (response.ok) {
            this.dispatchEvent(new CustomEvent("product:added", {
            bubbles: true,
            detail: {
                button: target,
                variant: null,
                quantity: parseInt(formElement.querySelector('[name="quantity"]').value)
            }
            }));
        } else {
            document.dispatchEvent(new CustomEvent("theme:loading:end"));
        }
        });
        event2.preventDefault();
    }
    };

    customElements.define('featured-collection-section', FeaturedCollectionSection);
}